import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'
import Vue3Lottie from 'vue3-lottie'
import VueSocials from 'vue-socials'

import VueGtag from 'vue-gtag'

import './plugins/firebase'

import './assets/css/style.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(Vue3Lottie)
  .use(VueSocials)
  .use(
    VueGtag,
    {
      config: {
        id: 'G-LNEB1Z0RN3',
        enabled: true,
      },
    },
    router
  )
  .mount('#app')
